import request from '../../../helpers/request';

export const fetchExportTypes = async () => {
  const response = await request.get(
    '/HousingStock/report_main_window/awailable',
    null,
    'При загрузке типов отчетов произошла ошибка'
  );
  return response;
};

export const fetchExportFields = async (exportTypeId) => {
  const response = await request.get(
    `/HousingStock/report_main_window/params/${exportTypeId}`,
    null,
    'При загрузке полей для отчета произошла ошибка'
  );
  return response;
};

export const fetchExportFieldOptions = async (url) => {
  const result = await request.get(
    url,
    null,
    'При загрузке опций для поля отчета произошла ошибка'
  );
  return result;
};

export const createReport = async (reportMethodUrl, reportParams) => {
  const response = await request.get(
    reportMethodUrl,
    reportParams,
    'При создании отчета произошла ошибка'
  );
  return response;
};
